// extracted by mini-css-extract-plugin
module.exports = {"root":"Lead-module--root--2YwJo","wrapper":"Lead-module--wrapper--FYgii","hero":"Lead-module--hero--1Mqx-","lead":"Lead-module--lead--1WfnK","tel":"Lead-module--tel--22sXG"};